import React from 'react';
import classNames from 'classnames';
import { TabPane as RcTabPane, TabPaneProps } from 'rc-tabs';
import { ConfigContext } from '../config-provider';
import { Icon } from '../icon';
export const TabPane = (props) => {
    const { className, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('tabs', props.prefixCls);
    const customClassName = classNames({
        [`${prefixCls}-tab-with-remove`]: props.closable,
        className
    });
    return React.createElement(RcTabPane, { className: customClassName, ...otherProps });
};
TabPane.defaultProps = {
    closeIcon: React.createElement(Icon, { type: 'close', size: 'small' })
};
// export default withConfigProvider(TabPane);
export default TabPane;
